var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowCta = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 21,
  height: 7.00007,
  viewBox: "0 0 21 7.00007",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group 17"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M19.5 3.50003L0.5 3.50003",
  stroke: "#FDF8ED",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M17.5 6.50003C17.5 6.50003 20.5 4.29058 20.5 3.50003C20.5 2.70943 17.5 0.500033 17.5 0.500033",
  stroke: "#FDF8ED",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowCta);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-arrow-cta.2bd7eafbcac083bebfb58c5147ab90b4.svg";